export default String.raw`
<dialog class="dialog validation-popup validation-popup-js middle">
	<div class="dialog__header">
        <svg height="32" width="32" fill="#DA2442">
            <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#exclamation-circle-{{settings.iconStyle}}"></use>
        </svg>
        {% comment -%} Dynamically inserted title or default {% endcomment -%}
		<h3 class="dialog__header-title validation-title-js" data-default-title="{{translations.NotAddedProducts}}">{{translations.NotAddedProducts}}</h3>
		<form method="dialog">
			<button class="dialog__close close-js" aria-label="{{ translations.Close }}">
				<svg aria-hidden="true" height="24" width="24">
					<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use>
				</svg>
			</button>
		</form>
	</div>
	<div class="dialog__content">
        {% comment -%} Dynamically inserted validation result below {% endcomment -%}
        <ul tabindex="-1" class="products__list products-js"></ul>
    </div>
    <div class="dialog__actions">
        <form method="dialog">
            <button class="primary-action-button close-js">
                <span>{{translations.Close}}</span>
            </button>
        </form>
    </div>
</dialog>
`